import React from "react";
import styles from "./index.module.css";

const StarSvg = ({ size = 20, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.787 1.402 8.173L12 18.896 4.664 23.17l1.402-8.173L.132 9.21l8.2-1.192z" />
  </svg>
);

const RideRating = ({ rating, size = 20, showText = true, starSpacing = 6, className = "" }) => {
  if (rating === undefined || rating === null || rating === "") return null;

  const num = Number(rating);
  if (Number.isNaN(num)) return null;

  const clamped = Math.max(0, Math.min(5, num));
  const pct = (clamped / 5) * 100;

  const stars = new Array(5).fill(0);

  const starStyle = { marginRight: `${starSpacing}px` };

  return (
    <div className={`${styles.wrapper} ${className}`} aria-label={`Rating ${clamped} out of 5`}>
      <div className={styles.stars} style={{ fontSize: 0 /* remove whitespace */ }}>
        <div className={styles.bg} aria-hidden>
          {stars.map((_, i) => (
            <span key={`bg-${i}`} style={i === stars.length - 1 ? {} : starStyle} className={styles.star}>
              <StarSvg size={size} color="#e0e0e0" />
            </span>
          ))}
        </div>

        <div
          className={styles.fg}
          style={{ width: `${pct}%` }}
          aria-hidden
        >
          {stars.map((_, i) => (
            <span key={`fg-${i}`} style={i === stars.length - 1 ? {} : starStyle} className={styles.star}>
              <StarSvg size={size} color="#faad14" />
            </span>
          ))}
        </div>
      </div>

      {showText && <span className={styles.text}>{clamped.toFixed(1)} / 5</span>}
    </div>
  );
};

export default RideRating;
